import { render } from "./AdPaymentFail.vue?vue&type=template&id=f2101984&scoped=true"
import script from "./AdPaymentFail.vue?vue&type=script&lang=js"
export * from "./AdPaymentFail.vue?vue&type=script&lang=js"

import "./AdPaymentFail.vue?vue&type=style&index=0&id=f2101984&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2101984"]])

export default __exports__